import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../data-access/auth.service';
import { map } from 'rxjs';
import {environment} from "../../../environments/environment";

export const authGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.token$.pipe(
    map((token) => {
      if (!token && environment.__auth_email === null) {
        router.navigate(['/login']);
        return false;
      }
      return true;
    })
  );
};
